import { useMapEvents } from 'react-leaflet'

// TODO: The map click handler should probably be something else than a react component
export default function MapClickHandler(props: any) {
  const { 
    relayClickLocations = false, 
    onMapClick = (latLng: any) => { }, 
    gpsTestingActive = false,
    onGpsTestClick = (lat: number, lng: number) => { },
    ...rest 
  } = props;
  
  const map = useMapEvents({
    click: (e) => {
      if (relayClickLocations) {
        onMapClick(e.latlng);
      } else if (gpsTestingActive) {
        onGpsTestClick(e.latlng.lat, e.latlng.lng);
      }
    },
  })
  return <></>
}